import type { ServiceResponse } from "./api.types";
import { privateAPI } from "./axios";

interface Insulin {
  id: string;
  label: string;
}

export const getInsulins = async () => {
  const { data } = await privateAPI.get<ServiceResponse<Insulin[]>>(`/insulin`);

  return data.data;
};
